<template>
  <div v-focus class="sign-out" tabindex="0" @keyup.esc="$emit('exit', false)">
    <img src="@/assets/signout/exit_background.png" alt="" class="background" />
    <img v-if="$i18n.locale === 'en'" src="@/assets/signout/exit_title_en.png" alt="" class="title-img" />
    <img v-else src="@/assets/signout/exit_title_es.png" alt="" class="title-img" />
    <div class="body">
      <img
        v-if="$i18n.locale === 'en'"
        src="@/assets/signout/exit_yes_en.png"
        alt=""
        class="yes"
        @click="$emit('exit', true)"
      />
      <img v-else src="@/assets/signout/exit_si_es.png" alt="" class="yes" @click="$emit('exit', true)" />
      <img src="@/assets/signout/exit_no_en.png" alt="" class="no" @click="$emit('exit', false)" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.sign-out {
  .background {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -150px;
    margin-left: -250px;
    height: 300px;
    width: 500px;
    z-index: 0;
  }
  .title-img {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -150px;
    margin-left: -250px;
    height: 300px;
    width: 500px;
    z-index: 1;
  }
  .body {
    z-index: 3;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -150px;
    margin-left: -250px;
    height: 300px;
    width: 500px;
    display: flex;
    justify-content: center;
    .yes,
    .no {
      width: 150px;
      height: 85px;
      position: absolute;
      bottom: 30px;
      &:hover {
        cursor: pointer;
        transform: scale(1.1);
      }
    }
    .yes {
      left: 40px;
    }
    .no {
      right: 40px;
    }
  }
}
</style>
